<template>
  <div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="'Delete ' + title"
        :active.sync="showPopup"
        class="popup-close small-popup"
        prevent-close
      >
        <div class="center">
          <img src="@/assets/images/pages/delete.svg" />
          <div class="success-msg">
            {{ $t("system.label.areYouSureDelete") }}
          </div>
        </div>

        <div class="center">
          <span class="p-2">
            <vs-button type="border" @click="$emit('cancelPressed')">{{
              $t("system.label.cancel")
            }}</vs-button></span
          >

          <span class="p-2">
            <vs-button @click="$emit('deletePressed')">{{
              $t("system.label.confirm")
            }}</vs-button>
          </span>
        </div>
        <div style="height: 20px"></div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
export default {
  name: "delete-popup",
  props: {
    title: String,
    deletePopup: { type: Boolean, default: false },
  },
  emits: ["deletePressed", "cancelPressed"],
  data() {
    return { showPopup: false };
  },
  computed: {},
  methods: {
    closedpopup() {
      this.$emit("closePopup");
    },
  },
  components: {},
  watch: {
    deletePopup(val) {
      this.showPopup = val;
    },
    showPopup(val) {
      if (!val) {
        this.$emit("cancelPressed");
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxCard.scss";
</style>
